import { useNavigate } from 'react-router-dom'

export const UnauthorizedAccess = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center h-full px-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold mb-4">403</h1>
        <h2 className="text-3xl font-semibold mb-4">Access Denied</h2>
        <p className="text-xl text-gray-600 mb-8">
          You don't have permission to access this page. This area is restricted to administrators only.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors text-lg font-medium"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  )
}
